import { composeFields, getDataMapper, mapField } from "../../../lib";

export const mapErrorFromServer = (object, dataErrorMapper, options) => {
    const mapperFunction = getDataMapper(
        {
            systemMessage: mapField("message", String),
            status: mapField("response", (item) => item.status),
            data: mapField(
                "response",
                ({ data }) =>
                    (dataErrorMapper && dataErrorMapper(data)) ||
                    getDataMapper({
                        // Причину отказа API отдаёт в поле error; message
                        // остаётся для ответов, собранных фреймворком.
                        // Без error пользователь видел системное
                        // «Request failed with status code …»
                        message: composeFields(
                            ["error", "message"],
                            ([error, message]) => error || message || null
                        ),
                        logId: mapField("log_id", String),
                    })(data)
            ),
        },
        options
    );

    return mapperFunction(object);
};
